var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPin2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 32,
    viewBox: "0 0 19 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.49967 26.3859L9.26967 26.1759C4.05967 21.4659 -1.76033 11.1159 0.609666 4.93586C1.79967 1.83586 4.78967 0.255859 9.49967 0.255859C14.2097 0.255859 17.1897 1.82586 18.3897 4.93586C20.7597 11.1059 14.9497 21.4659 9.72967 26.1759L9.49967 26.3859ZM9.49967 0.955858C5.10967 0.955858 2.33967 2.38586 1.24967 5.19586C-0.820334 10.5759 3.86967 20.2459 9.49967 25.4659C15.1297 20.2359 19.8097 10.5759 17.7497 5.19586C16.6697 2.38586 13.8897 0.955858 9.49967 0.955858ZM9.49967 6.69586C7.22967 6.69586 5.38967 8.54586 5.38967 10.8059C5.38967 13.0659 7.22967 14.9159 9.49967 14.9159C11.7697 14.9159 13.6097 13.0659 13.6097 10.8059C13.6097 8.54586 11.7697 6.69586 9.49967 6.69586Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49986 31.7467C11.9244 31.7467 13.8899 30.9946 13.8899 30.0667C13.8899 29.1389 11.9244 28.3867 9.49986 28.3867C7.07533 28.3867 5.10986 29.1389 5.10986 30.0667C5.10986 30.9946 7.07533 31.7467 9.49986 31.7467Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin2);
export default __webpack_public_path__ + "static/media/pin2.f5552766c262f97d8db8fdd02ba8f259.svg";
export { ForwardRef as ReactComponent };